import {DocumentAmendment} from "common/flowmaster/types/amendment";
import {generateMultiLineAmendments} from "./multiline/generate_multi_line_amendments";
import fixDeleteAmendmentOverlappingText from "./preprocessing/fix_delete_overlapping_text";

type FixerFn = (amendment: DocumentAmendment) => DocumentAmendment;

const fixerFns: FixerFn[] = [
  fixDeleteAmendmentOverlappingText,
  generateMultiLineAmendments,
];

function fixAmendment(amendment: DocumentAmendment): DocumentAmendment {
  const fixed = fixerFns.reduce((prevAmendment, fn) => {
    return fn(prevAmendment);
  }, amendment);

  return fixed;
}

export default function fixBadLlmAmendments(
  amendments: DocumentAmendment[],
): DocumentAmendment[] {
  return amendments.map((amendment, index) => {
    try {
      return fixAmendment(amendment);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(`Error fixing amendment ${index}: ${error.message}`);
      return amendment;
    }
  });
}
